import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SearchService } from '../../common/services/search.service';
import { Observable } from 'rxjs/Observable';
import { UPDATESTATE } from '../reducers/search-state';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { GaService } from '../../common/services/ga.service';

@Component({
  selector: 'quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.scss']
})
export class QuickSearchComponent {
  public searchTerm: string;
  public dataSource: Observable<any>;
  public suggestionCtrl: FormControl = new FormControl();
  public mainSearchForm: FormGroup = new FormGroup({
    searchTerm: this.suggestionCtrl
  });

  // spinner when users clicks enter or selects from typeahead
  searchProgress;

  // spiner for typeahead
  searchTypeahead;

  public constructor(
    private router: Router,
    private store: Store<any>,
    private searchService: SearchService,
    private gaService: GaService,
  ) {
    this.dataSource = Observable.create((observer: any) => {
      let trimSearchTerm = this.searchTerm.trim();
      this.searchTypeahead = true;
      this.searchService
        .typeAhead({ searchTerm: trimSearchTerm, searchType: 'allSuggest' })
        .subscribe(
          ({ data }) => {
            this.searchTypeahead = false;
            if (this.searchTerm === '') {
              observer.next(data.searchSuggestion);
            } else {
              this.searchTypeahead = false;
              let newSuggestionArray = data.searchSuggestion.slice(0);
              newSuggestionArray.unshift(this.searchTerm);
              observer.next(newSuggestionArray);
            }
          },
          error => {
            this.searchTypeahead = false;
            this.searchProgress = false;
            console.log(error);
          }
        );
    });
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.search();
  }

  onSubmit() {
    this.search();
  }

  search() {
    this.searchTerm = this.mainSearchForm.value.searchTerm;
    this.searchProgress = true;
    if (this.searchTerm) {
      this.searchService
        .advancedSearch({ searchTerm: this.searchTerm, searchType: 'all', pageNum: 1 })
        .subscribe(
          ({ data }) => {
            this.searchProgress = 'done';
            this.store.dispatch({
              type: UPDATESTATE,
              payload: {
                total: data.search.total,
                result: data.search.result,
                pageNum: 1,
                searchTerm: this.searchTerm,
                filterResultsBy: 'All Items',
                searchBy: 'all',
                typeaheadSuggest: 'allSuggest',
                state: null,
                cities: [],
                counties: [],
                isStateSelected: false
              }
            });

            //google analytics
            this.gaService.addSearch(this.searchTerm);

            this.router.navigate(['searchResults']);
          },
          error => {
            console.log(error);
            this.searchProgress = false;
          }
        );
    } else {
      this.router.navigate(['searchResults']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/search/quick-search/quick-search.component.ts